import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=04734bf4&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=04734bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04734bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04734bf4')) {
      api.createRecord('04734bf4', component.options)
    } else {
      api.reload('04734bf4', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=04734bf4&scoped=true&", function () {
      api.rerender('04734bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u5XJyY7FrHdU/JS/comp/DateRange.vue"
export default component.exports